<img *ngIf="icon?.src"
     [src]="icon.src"
     [alt]="icon.alt"
     [style.filter]="invert ? 'invert(1)' : 'invert(0)'"
>
